export const MicIcon = require("./ic-mic.svg").default;
export const CloseIcon = require("./ic-close.svg").default;
export const ProfileBlob = require("./profile-blob.png");

export const PauseIcon = require("./ic-pause.svg").default;
export const StopIcon = require("./ic-stop.svg").default;
export const ResetIcon = require("./ic-reset.svg").default;
export const SendIcon = require("./ic-send.svg").default;
export const CopyIcon = require("./ic-copy.svg").default;
export const OrbitIcon = require("./ic-orbit.svg").default;
export const MicDarkIcon = require("./ic-mic-dark.svg").default;
